import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import { IDetailRowProps } from '../../types';
import * as styles from './DetailRow.css';
import { NBSP } from '../../../../constants/symbols';

export const DetailRow = ({ label, description, price, isDiscount }: IDetailRowProps) => (
  <div className={styles['row']}>
    <UIText2 whiteSpace="nowrap">{label}</UIText2>
    {description && (
      <>
        {NBSP}
        <UIText2 color="black_60" whiteSpace="nowrap">
          ({description})
        </UIText2>
      </>
    )}
    <div className={styles['divider']} />
    <div className={styles['right-block']}>
      <div data-name="service_cost">
        <UIText2 color={isDiscount ? 'error_100' : undefined} whiteSpace="nowrap">
          {price}
        </UIText2>
      </div>
    </div>
  </div>
);
